import Permissions from 'src/security/permissions';
import { i18n } from 'src/i18n';
import config from 'src/config';

const permissions = Permissions.values;

export default [
  {
    path: '/admin/event',
    exact: true,
    icon: 'fas fa-th-large',
    label: i18n('entities.event.menu'),
    permissionRequired: null,
  },
  
  {
    path: '/admin/user',
    label: i18n('user.menu'),
    permissionRequired: permissions.userCreate,
    icon: 'fas fa-user-plus',
  },

  {
    path: '/admin/tag',
    permissionRequired: permissions.tagCreate,
    icon: 'fas fa-chevron-right',
    label: i18n('entities.tag.menu'),
  },

  {
    path: '/admin/category',
    permissionRequired: permissions.categoryCreate,
    icon: 'fas fa-chevron-right',
    label: i18n('entities.category.menu'),
  },    

  {
    path: '/admin/event-class',
    permissionRequired: permissions.eventClassCreate,
    icon: 'fas fa-chevron-right',
    label: i18n('entities.eventClass.menu'),
  },

  /*
  {
    path: '/event-time-zone',
    permissionRequired: permissions.eventTimeZoneRead,
    icon: 'fas fa-chevron-right',
    label: i18n('entities.eventTimeZone.menu'),
  },
  */

   {
    path: '/admin/country',
    permissionRequired: permissions.countryRead,    
    icon: 'fas fa-chevron-right',
    label: i18n('entities.country.menu'),
  },

  {
    path: '/country-state',
    permissionRequired: permissions.countryStateRead,
    icon: 'fas fa-chevron-right',
    label: i18n('entities.countryState.menu'),
  },  

  {
    path: '/admin/place',
    permissionRequired: permissions.placeRead,
    icon: 'fas fa-chevron-right',
    label: i18n('entities.place.menu'),
  },
  {
    path: '/admin/event-schedule',
    permissionRequired: permissions.eventScheduleRead,
    icon: 'fas fa-chevron-right',
    label: i18n('entities.eventSchedule.menu'),
  },
  {
    path: '/position',
    permissionRequired: permissions.positionRead,
    icon: 'fas fa-chevron-right',
    label: i18n('entities.position.menu'),
  },  
  {
    path: '/contact',
    permissionRequired: permissions.contactRead,
    icon: 'fas fa-chevron-right',
    label: i18n('entities.contact.menu'),
  },
  {
    path: '/admin/settings',
    icon: 'fas fa-cog',
    label: i18n('settings.menu'),
    permissionRequired: permissions.settingsEdit,
  },   
].filter(Boolean);
